import { render, staticRenderFns } from "./Fail.vue?vue&type=template&id=3ddf6244"
import script from "./Fail.vue?vue&type=script&lang=js"
export * from "./Fail.vue?vue&type=script&lang=js"
import style0 from "./Fail.vue?vue&type=style&index=0&id=3ddf6244&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports